<template>
	<div class="bg">
        <div class="page1" v-show="display">
            <!-- <div class="item">
                <div class="backbtn" @click="goback()">
                    <i class="su-icon-zuojiantou"></i>
                    <span>返回</span>
                </div>
            </div> -->
            <div class="content">
                <p class="title">注册邮箱</p>
                <p class="input-title">邮箱名称</p>
                <sw-input placeholder="科研邮箱、办公邮箱等，2-6个字" v-model="emailName"  maxlength="6" @blur="checkinput('emailName')"></sw-input>
                <p class="input-title">邮箱账号</p>
                <sw-input placeholder="必须是小写字母/数字/下划线" v-model="emailAccount" @blur="checkinput('emailAccount')">
                    <template slot="append">{{this.mailSuffix}}</template>
                </sw-input>
                <p class="input-title">邮箱密码</p>
                <sw-input placeholder="8-16位字符，最少包含两种类型字符" v-model="password" show-password @blur="checkinput('pwd')"></sw-input>
                <p class="input-title">确认密码</p>
                <sw-input placeholder="请再次输入密码" v-model="confirmPassword" show-password  @blur="checkinput('cfspwd')"></sw-input>
                <sw-button round :class="{active:activeBtn}" @click="register()">注册</sw-button>
            </div>
        </div>
        <div class="page2" v-show="display2">
            <img src="@/assets/xigongda/email-registered.png" class="success-pic">
            <p class="success-text">注册成功</p>
        </div>
        <transition name="flash">
            <sw-tip icon="su-icon-error" v-if="show">
                <div slot="text">
                    <div>{{this.message}}</div>
                </div>
            </sw-tip>
        </transition>
        <transition name="flash">
            <sw-tip  v-if="show2" :show-icon="false">
                <div slot="text">
                    <div>{{this.message}}</div>
                </div>
            </sw-tip>
        </transition>
    </div>
</template>

<script>
    import { getMailSuffix,registerEmailBox,checkEmailBoxIsExist } from '@/api/xisu.js';
    import { setToken } from "@/utils/auth";
	export default {
		components: {

		},
		data() {
            return {
                mailSuffix:'',
                emailName:'',
                emailAccount:'',
				password:'',
                confirmPassword:'',
                activeBtn:false,
                regflag:false,
                regflag2:false,
                message:'',
                show:false,
                show2:false,
                display:true,
                display2:false
			}
		},
        created(){
            this.mydecodeTicket();
        },
		methods: {
            mydecodeTicket(){
                console.log(location.href);
                if (location.href.indexOf("token=") != -1) {
                    let url = location.href;
                    let token = url.split('=')[1];
                    setToken(token);
                }
                this.mygetMailSuffix();
            },
            mygetMailSuffix(){
                getMailSuffix().then(res =>{
                    if(res.code == 0){//获取邮箱后缀
                            this.mailSuffix = res.data.mailSuffix
                    }else{
                        this.showTost2(res.message)
                    }
                })
            },
            goback(){
                
            },
            checkinput(e){
				var val = '';
                if( e == 'emailAccount'){
                    val = this.emailAccount;
                }else if( e == 'pwd'){
                    val = this.password;
                }else if( e == 'cfspwd'){
                    val = this.confirmPassword;
                }
				var reg = /^[a-z0-9_]*$/g;
				var reg2= /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;
				if( val !='' ){
					if( e == 'emailAccount' ){
						if( !reg.test(val)){
                            this.showTost2('邮箱账号只允许输入小写字母、数字、下划线');
						}else{
                            let data = {
                                "emailAddress":this.emailAccount
                            }
                            checkEmailBoxIsExist(data).then(res =>{
                                if(res.code == 0){
                                    if(res.data.isExist){
                                        this.showTost2('该邮箱已注册');
                                    }
                                }else{
                                    this.showTost2('检测邮箱失败');
                                }
                            })
                        }
					}
					if( e == 'pwd' || e == 'cfspwd'){
						if( !reg2.test(val)){
                            this.showTost('密码格式错误');
							this.regflag = false;
						}else{
							this.regflag = true;
						}
						if( this.password!='' && this.confirmPassword!='' ){
							if( this.password != this.confirmPassword){
                                this.showTost('两次填写密码不一致');
								this.regflag2 = false;
							}else{
								this.regflag2 = true;
							}
							
						}
					}
				}
				if( this.emailName!='' && this.emailAccount!='' && this.password!='' && this.confirmPassword!='' && this.regflag && this.regflag2) {
					this.activeBtn = true;
				}else{
					this.activeBtn = false;
				}
			},
            showTost(msg){
                if(!this.show){
                    this.show = !this.show;
                    this.message = msg;
                    setTimeout(() => {
                        this.show = !this.show;
                    } ,2000)
                }
            },
            showTost2(msg){
                if(!this.show2){
                    this.show2 = !this.show2;
                    this.message = msg;
                    setTimeout(() => {
                        this.show2 = !this.show2;
                    } ,2000)
                }
            },
            /* 注册按钮 */
			register(){
				if( !this.activeBtn ){
					return 
				}else{
                    let email = {
                        "emailAddress": this.emailAccount,
                        "emailName": this.emailName,
                        "extras": {},
                        "id": "",
                        "mainEmail": false,
                        "password": this.password,
                        "showOnIndex": true,
                        "userType": ""
                    }
                    registerEmailBox(email).then(res => {
                        console.log(res)
                        if(res.code == 0){//注册成功切换页面
                            this.display = false;
                            this.display2 = true;
                        }else{
                            this.showTost2(res.message)
                        }
				    })
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
    .bg{
        width: 100%;
        height: 100%;
        background-color: #FFFFFF;
        .page1{
            width: inherit;
            height: inherit;
            .item{
                width: 100%;
                height:48px;
                line-height:48px;
            }
            .backbtn{
                width: 100px;
                height: 48px;
                padding-left: 10px;
                font-size: 16px;
                .su-icon-zuojiantou:before{
                    color: #1F2021;
                    font-weight: bold;
                }
                span{
                    padding-left: 5px;
                }
            }
            .content{
                width: 100%;
                height: auto;
                padding: 0 27px;
                color: #3A3C40;
                font-family: PingFangSC-Medium, PingFang SC;
                .title{
                    height: 30px;
                    font-size: 32px;
                    font-weight: 500;
                    line-height: 32px;
                    margin: 27px 0px 50px;
                }
                .sub-title{
                    height: 15px;
                    font-size: 15px;
                    line-height: 15px;
                    font-weight: 400;
                    margin-bottom: 45px;
                }
                .input-title{
                    font-size: 17px;
                    font-weight: 400;
                    color: rgba(58, 60, 64, 1);
                    line-height: 17px;
                    margin-top: 22px;
                }
                .sw-input{
                    border-bottom: 1px solid #D9DCE0 ;
                    font-size: 16px;
                }
                .tpis{
                    width: 100%;
                    min-height: 50px;
                    margin: 0 auto;
                    background-color: #F1F3F6;
                    margin-top: 25px;
                    font-size: 14px;
                    line-height: 20px;
                    padding: 6px 16px;
                }
                .sw-button{
                    width: 100%;
                    height: 44px;
                    background-color: rgba(237, 102, 63, 0.4);
                    border: unset;
                    border-radius: 22px;
                    justify-content: center;
                    align-items: center;
                    margin-top: 45px;
                    color: #fff;
                }
                .sw-button.active{
                    background-color: rgba(237, 102, 63, 1);
                }
                .sw-button:focus, .sw-button:hover{
                    background-color: rgba(237, 102, 63, 0.4);
                    border:unset;
                }
                .sw-button.active:focus, .sw-button.active:hover{
                    background-color: rgba(237, 102, 63, 1);
                }
                /deep/ .el-input-group__append{
                    border: unset;
                    background-color: #ffffff;
                    padding: 0 10px;
                }
            }
        }
        .page2{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .success-pic{
                width: 165px;
                height: 165px;
                margin: 110px 0 11px;
            }
            .success-text{
                height: 18px;
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #1F2021;
                line-height: 18px;
            }
            .sw-button{
                width: 76%;
                height: 44px;
                background-color: #F1F3F6;
                border-radius: 22px;
                justify-content: center;
                align-items: center;
                margin-top: 45px;
                border:unset;
                color: #3A3C40;
            }
            
            .sw-button:focus, .sw-button:hover{
                background-color: #F1F3F6;
                border:unset;
            }
        }
        .sw-tip{
            width: 185px;
            min-height: 113px;
            position: absolute;
            margin: 70% auto;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            border-radius: 10px;
            border-color: rgba(0, 0, 0, 0.6);
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            /deep/ .sw-tip_icon{
                margin-right:0px;
            }
             /deep/ .su-icon-error:before{
                    color: #fff;
                    font-size: 30px;
                }
            /deep/ .sw-tip_text{
                color: #FFF;
                margin-right:0px;
                font-size: 15px;
                flex: 0;
            }
        }
    }
    /deep/ .el-input__inner{
        border:unset!important;
        padding-left: 0px;
        margin: 10px 0;
    }

    /deep/ .su-icon-hide:before{
            content: "\e7a7"!important;
        }
    /deep/ .su-icon-display:before{
            content: "\e7a3"!important;
        }

    .flash-enter-active, .flash-leave-active {
        transition: opacity 0.8s;
    }
    .flash-enter, .flash-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }









	.emailBtn {
		width: 650rpx;
		height: 88rpx;
		background-color: rgba(237, 102, 63, 0.4);
		border-radius: 44rpx;
		justify-content: center;
		align-items: center;
		margin-top: 90rpx;
	}
	.emailBtn.active{
		background-color: rgba(237, 102, 63, 1);
	}
	.gobackBtn {
		width: 650rpx;
		height: 88rpx;
		background-color: #F1F3F6;
		border-radius: 44rpx;
		justify-content: center;
		align-items: center;
		margin-top: 90rpx;
	}
	.success-pic{
		width: 300rpx;
		height: 300rpx;
		margin: 200rpx 0 20rpx;
	}
	.success-text{
		height: 36rpx;
		font-size: 36rpx;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #1F2021;
		line-height: 36rpx;
	}
	.succnext{
		font-size: 34rpx;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		line-height: 34rpx;
		color: rgba(58, 60, 64, 1);
	}
	.warn{
		background: #F1F3F6;
		padding: 12rpx 30rpx;
		font-size: 26rpx;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6F737A;
		line-height: 38rpx;
		margin-top: 50rpx;
	}
</style>